import { render, staticRenderFns } from "./DetailsFiltre.vue?vue&type=template&id=fe07bfac&scoped=true&"
import script from "./DetailsFiltre.vue?vue&type=script&lang=ts&"
export * from "./DetailsFiltre.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe07bfac",
  null
  
)

export default component.exports